import { render, staticRenderFns } from "./InputBirthday.vue?vue&type=template&id=3c0da684&scoped=true&"
import script from "./InputBirthday.vue?vue&type=script&lang=js&"
export * from "./InputBirthday.vue?vue&type=script&lang=js&"
import style0 from "./InputBirthday.vue?vue&type=style&index=0&id=3c0da684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0da684",
  null
  
)

export default component.exports